import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { lastValueFrom } from 'rxjs';

// PrimeNg
import { ButtonModule } from 'primeng/button';

// Services
import { BotoneraApiService } from '../botonera.api.service';
import { IFormSearchLupa, Item } from '../../general/lupas/interfaces/lupas.interfaces';
import { LupasComponent } from '../../general/lupas/lupas.component';
import { InputTextModule } from 'primeng/inputtext';
import { IFirmaCertificada } from '../botonera.interface';
import { UserInteractiveService } from '@/Services/user-interactive.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TypeStateSign } from '../botonera.enums';

@Component({
  selector: 'app-modal-firma-certificada',
  standalone: true,
  imports: [ReactiveFormsModule, ButtonModule, LupasComponent, InputTextModule],
  templateUrl: './modal-firma-certificada.component.html',
  styleUrl: './modal-firma-certificada.component.scss',
})
export class ModalFirmaCertificadaComponent {
  apiService = inject(BotoneraApiService);
  fb = inject(FormBuilder);
  userInteractiveService = inject(UserInteractiveService);

  form: FormGroup = this.fb.group({});
  modal?: DynamicDialogRef;
  firmaCertificada = signal<IFirmaCertificada | undefined>(undefined);
  typesStateSign = TypeStateSign;

  // lupa
  dataSearchLupaUsuario: IFormSearchLupa = {
    idFormulario: 'form_fdArchivosPasos',
    campo: 'Participantes',
    label: 'Participantes',
    required: true,
  };

  constructor() {
    this.getInfoModal();
    this.buildForm();
  }

  getInfoModal() {
    this.modal = this.userInteractiveService.getConfigDialog()?.ref;
    this.firmaCertificada.set(this.userInteractiveService.getConfigDialog()?.config.data);
  }

  buildForm() {
    this.form = this.fb.group({
      CodRadicado: this.fb.control(this.firmaCertificada()?.CodRadicado),
      IdfdArchivo: this.fb.control(this.firmaCertificada()?.IdfdArchivo),
      Usuario: this.fb.control(null, Validators.required),
      Participantes: this.fb.control(null, [Validators.required, Validators.email]),
    });
  }

  async onConfirmar() {
    const firmante: IFirmaCertificada = this.form.getRawValue();
    const response = await lastValueFrom(this.apiService.PostFirmaCertificada(firmante));
    if(response) this.modal?.close(response);
  }

  async onVerificar() {
    const response = await lastValueFrom(this.apiService.PutFirmaCertificada(this.firmaCertificada()!));
    if (response) this.modal?.close(response);
  }

  onCerrarModal() {
    this.modal?.close(false);
  }

  onUsuarioSeleccionado(item: Item) {
    const properties = (item.Propiedades ?? {}) as IFirmaCertificada;
    this.form.get('Participantes')?.setValue(properties.Participantes);
    this.form.updateValueAndValidity();
  }
}
